export class Control {
    'id';
    'name';
    'severity';
    'condition';
    'rules';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "Severity",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "rules",
            "baseName": "rules",
            "type": "ControlRules",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Control.attributeTypeMap;
    }
    constructor() {
    }
}
